import { render } from "./ItemDeQuestaoOpcao.vue?vue&type=template&id=69cfe346&ts=true"
import script from "./ItemDeQuestaoOpcao.vue?vue&type=script&lang=ts"
export * from "./ItemDeQuestaoOpcao.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__